import { render } from "./PlayerModel.vue?vue&type=template&id=25ccbf7a"
import script from "./PlayerModel.vue?vue&type=script&lang=js"
export * from "./PlayerModel.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__